import { CodeHighlightAdapterProvider, createShikiAdapter } from '@mantine/code-highlight';
import '@mantine/code-highlight/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { HIGHLIGHT_LANGUAGES } from './util/highlight-languages.ts';
import './util/mixpanel.ts';

// Shiki requires async code to load the highlighter
async function loadShiki() {
  const { createHighlighter } = await import('shiki');
  const shiki = await createHighlighter({
    langs: HIGHLIGHT_LANGUAGES,
    // You can load supported themes here
    themes: [],
  });

  return shiki;
}

const shikiAdapter = createShikiAdapter(loadShiki);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CodeHighlightAdapterProvider adapter={shikiAdapter}>
      <MantineProvider defaultColorScheme="auto">
        <App />
      </MantineProvider>
    </CodeHighlightAdapterProvider>
  </React.StrictMode>,
);
